import React from 'react';
import ReactDOM from 'react-dom';
import domready from 'domready';
import { match } from 'react-router';
import { load as loadHypernova } from 'hypernova';

import UrlGenerator from './lib/UrlGenerator';

const FastClick = require('fastclick');
const createRoutes = require('./routes').default;
const HypernovaComponents = require('./hypernova').default;

domready(() => {
    const findComponent = name => HypernovaComponents[name] || null;

    const renderReact = (el, componentName, props) => {
        const Component = findComponent(componentName);
        if (Component === null) {
            console.warn(`Component ${componentName} not found.`);
            return;
        }

        const element = React.createElement(Component, props);
        ReactDOM.render(element, el);
    };

    const createRenderReact = (...args) => () => renderReact(...args);

    const renderHypernovaElements = (elements) => {
        Array.prototype.slice.call(elements).forEach((el) => {
            const componentName = el.dataset ? el.dataset.hypernovaKey : el.getAttribute('data-hypernova-key');
            const nodes = loadHypernova(componentName);
            nodes.forEach(({ node, data }) => {
                const props = {
                    ...data,
                };
                if (typeof window === 'undefined' && typeof props.url !== 'undefined') {
                    const urlGenerator = new UrlGenerator(data.routes || null);
                    const routes = createRoutes(urlGenerator);
                    match({
                        routes,
                        location: data.url,
                    }, createRenderReact(node, componentName, {
                        ...props,
                        routerRoutes: routes,
                        urlGenerator,
                    }));
                } else {
                    renderReact(node, componentName, props);
                }
            });
        });
    };

    FastClick.attach(document.body);

    const hypernovaElements = document.querySelectorAll('div[data-hypernova-key]');
    renderHypernovaElements(hypernovaElements);
});



// WEBPACK FOOTER //
// ./index.js